import { NextParsedUrlQuery } from 'next/dist/server/request-meta'

type ParseQueryFieldSuccess<T extends string | number | object> = T extends 'number'
  ? number
  : T extends 'string'
  ? string
  : T[keyof T]

export function parseQueryField<T extends string | number | object>(
  query: NextParsedUrlQuery,
  field: string,
  type: T,
): ParseQueryFieldSuccess<T> | undefined {
  const value = query[field]?.toString()

  if (value === undefined) {
    return undefined
  }

  if (type === 'number') {
    const parsedNumber = Number(value.toString())
    return isNaN(parsedNumber) ? undefined : (parsedNumber as ParseQueryFieldSuccess<T>)
  }

  if (type === 'string') {
    const stringValue = String(value)
    if (stringValue === 'null') return undefined
    return String(value) as ParseQueryFieldSuccess<T>
  }

  // Enum 처리 부분
  if (typeof type === 'object' && Object.values(type as object).includes(value)) {
    return value as ParseQueryFieldSuccess<T>
  }

  return undefined
}

/**
 * 두 query 객체를 합하는 유틸 함수
 * 빈 문자열("")이나 명시적 null 인경우 키를 삭제합니다.
 *
 * @param prev 이전 query 객체
 * @param next 업데이트할 query 객체 (partial)
 * @returns prev 에 next 를 merge 한 query 객체
 */
export function mergeQueryParams(
  prev: Record<string, string[] | string | null | undefined>,
  next: Record<string, string[] | string | null | undefined>,
) {
  const merged = { ...prev }

  Object.keys(next).forEach(key => {
    if (next[key] == null || next[key] === '') {
      delete merged[key]
    } else {
      merged[key] = next[key]
    }
  })

  return merged
}
